import { ActivityInstance, ActivityInstanceStatus, UpdateActivityInstanceStateAddendum } from '@things-factory/worklist'

import { DataOoc, DataOocStatus } from '../service/data-ooc/data-ooc.js'
import { issueOocResolve } from '../controllers/issue-ooc-resolve.js'

async function callback(
  activityInstance: ActivityInstance,
  addendum: UpdateActivityInstanceStateAddendum,
  context: ResolverContext
) {
  const { domain, user, tx } = context.state
  const { input, output, state, terminatedAt } = activityInstance
  const { causedBy } = addendum || {}

  if (state == ActivityInstanceStatus.Ended) {
    const { dataOocId } = input
    const correctiveInstruction = output?.instruction

    var dataOoc = await tx.getRepository(DataOoc).findOne({
      where: {
        domain: { id: domain.id },
        id: dataOocId
      },
      relations: ['dataSet']
    })

    const dataSet = dataOoc.dataSet

    /* dataOoc Review 결과를 dataOoc 엔티티에 반영한다. */
    dataOoc = await tx.getRepository(DataOoc).save({
      ...dataOoc,
      reviewedAt: terminatedAt,
      reviewer: user,
      correctiveInstruction,
      state: DataOocStatus.REVIEWED
    })

    // save() 후 dataSet relation이 손실되므로 다시 설정
    dataOoc.dataSet = dataSet

    await issueOocResolve(dataOoc, dataSet, correctiveInstruction, context)
  }
}

export const ActivityOocReview = {
  name: 'OOC Review',
  description: 'Task to take remedial action based on Out Of Control data',
  release: '1.0.0',
  provider: 'hatiolab.com',
  category: 'quality',
  activityType: 'user',
  priority: 2,
  searchKeys: [
    {
      name: 'dataOocId',
      description: 'OOC Id.',
      inputKey: 'dataOocId',
      tKey: 'data-ooc-id'
    }
  ],
  startingType: '',
  multiple: 'single',
  model: [
    {
      name: 'dataOocId',
      description: 'OOC id',
      tag: 'dataOocId',
      hidden: true,
      mandatory: true,
      inout: 'in',
      type: 'string',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    },
    {
      name: 'Instruction',
      description: 'Instructions for preventing OOC',
      tag: 'instruction',
      hidden: false,
      mandatory: true,
      inout: 'out',
      type: 'textarea',
      options: {},
      unit: null,
      quantifier: [1],
      spec: {}
    }
  ],
  uiType: 'custom-element',
  uiSource: 'activity-ooc-review-edit',
  viewType: 'custom-element',
  viewSource: 'activity-ooc-review-view',
  reportType: 'custom-element',
  reportSource: 'data-ooc-report-page',
  thumbnail: '/assets/images/ooc.png',
  standardTime: 24 * 60 * 60, // seconds
  callback /* Called when there is a change in the lifecycle of a task (activity-instance). */
}
